const home = {
  pageTitle: "51吃瓜网 - 每日吃瓜必吃 · 黑料爆料第一站",
  pageDescription: "51吃瓜网官方网站，每日更新51吃瓜今日吃瓜必吃大瓜，汇聚每日大赛正能量、黑料免费爆料与网红大瓜。",
  hero: {
    title1: "每日吃瓜必吃",
    title2: "黑料爆料第一站",
    title3: "正能量不打烊",
    cta: "开始吃瓜",
    bottomSlogan: "每日吃瓜必吃 · 黑料爆料第一站",
  },
  hotSection: {
    label: "每日热点瓜闻",
    description: "追踪最热门的娱乐八卦，一分钟掌握今日必吃大瓜。实时更新，永不掉队。",
    readMore: "查看详情",
  },
  commentSection: {
    label: "瓜友热评",
    title1: "吃瓜群众",
    title2: "怎么说",
  },
  structuredData: {
    webpageName: "51吃瓜网 - 首页",
    webpageDescription: "51吃瓜网官方网站首页，每日更新热点瓜闻、网红爆料、娱乐资讯。",
  },
};

export default home;